import HomeSlider from "./home-slider.component";

export default HomeSlider;
